import _slicedToArray from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as d, useEffect as o } from "react";
var f = function f(t, i) {
    return i !== void 0 ? i : typeof window < "u" ? window.matchMedia(t).matches : (process.env.NODE_ENV !== "production" && console.warn("`useMedia` When server side rendering, defaultState should be defined to prevent a hydration mismatches."), !1);
  },
  m = function m(t, i) {
    var _d = d(f(t, i)),
      _d2 = _slicedToArray(_d, 2),
      s = _d2[0],
      a = _d2[1];
    return o(function () {
      var r = !0;
      var e = window.matchMedia(t),
        n = function n() {
          r && a(!!e.matches);
        };
      return "addEventListener" in e ? e.addEventListener("change", n) : "addListener" in e && e.addListener(n), n(), function () {
        r = !1, "removeEventListener" in e ? e.removeEventListener("change", n) : "removeListener" in e && e.removeListener(n);
      };
    }, [t]), s;
  };
export { m as default };